import { isVisibleToCustomers } from '@esentai/core/features/productView/selectors';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { moveViewUp } from '@/features/productsViewPage/actions';

import MoveUpButton from './component';

const mapDispatchToProps = (dispatch, { itemId }) => ({
  onClick: () => dispatch(moveViewUp(itemId)),
});

const mapStateToProps = (state, { itemId }) => ({
  isVisible: isVisibleToCustomers(state, itemId),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'onClick' }),
)(MoveUpButton);
